import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DbservicesProvider,ChatService } from '../../providers/dbservices/dbservices';
import ApexCharts from 'apexcharts'
import {HomePage} from '../../pages/home/home';
import {ReportlistPage} from '../../pages/reportlist/reportlist';

@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {

  dashboards: any = [];
  isOnline: any;
  pageloaded;
  
  constructor(public chatservice: ChatService,public DBservice: DbservicesProvider, public navCtrl: NavController, public navParams: NavParams) {
    // this.isOnline = true;
    // this.dashboard()

  }

  getPaddedComp(comp) {
    return ((parseInt(comp) < 10) ? ('0' + comp) : comp)
  }

   get_Url() {
    this.DBservice.get_url()
      .subscribe(res => {
        // this.DBservice.domain = res.domain;
        // this.DBservice.restaurant = res.businessId;
        this.DBservice.baseUrl = res;
        this.chatservice.socketurl = res;
        this.DBservice.baseResource = res + '/api/resource/'
        this.DBservice.baseMethod = res + '/api/method/';
         this.update_playid()
    this.dashboard()

    this.validate_business_opening();
    var aa= new Date()
    var date = aa.getFullYear() + '-' + (this.getPaddedComp(aa.getMonth() + 1)) + '-' + this.getPaddedComp(aa.getDate());
    if(localStorage.setdate == undefined)
      date = undefined
    if (localStorage.AdminId != undefined && date == localStorage.setdate) {
      var logindata = {
        username: localStorage.AdminId,
        password: localStorage.AdminPwd
      }
      this.DBservice.getLogin(logindata).then(
        data => {
          var currentDate = new Date()
          localStorage.setdate = currentDate.getFullYear() + '-' + (this.getPaddedComp(currentDate.getMonth() + 1)) + '-' + this.getPaddedComp(currentDate.getDate() +1);

        }, error => {
          console.log(JSON.stringify(error.json()));
        });
    }
    // if (localStorage.AdminId != undefined) {
    //   var logindata = {
    //     username: localStorage.AdminId,
    //     password: localStorage.AdminPwd
    //   }
    //   this.DBservice.getLogin(logindata).then(
    //     data => {
    //     }, error => {
    //       console.log(JSON.stringify(error.json()));
    //     });
    // }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
  }

  gotoorder(detail){
  if(detail.title.match(/Today/))
    this.navCtrl.setRoot(ReportlistPage)
  else
    this.navCtrl.setRoot(HomePage)

  }

  ionViewWillEnter() {
    this.get_Url()
    // this.update_playid()
    // this.dashboard()

    // this.validate_business_opening()
    // if (localStorage.AdminId != undefined) {
    //   var logindata = {
    //     username: localStorage.AdminId,
    //     password: localStorage.AdminPwd
    //   }
    //   this.DBservice.getLogin(logindata).then(
    //     data => {
    //     }, error => {
    //       console.log(JSON.stringify(error.json()));
    //     });
    // }
    
    // if (localStorage.BusinessId != "null") {
    //   this.dashboard()
    // }
  }

  validate_business_opening(){
    var data={
        business:localStorage.restaurant
    }
    this.DBservice.validate_business_opening(data)
      .then(res => {
        console.log(res.message);
        if(res.message.available == 1)
          this.isOnline = true
        else
          this.isOnline = false
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
    }
  // }

update_playid() {
    if (localStorage.adminRefId) {
      var datas = {
        // player_id: localStorage.deviceid,
        // user:localStorage.adminRefId,
        // user_type:"Shop User"
        document:'Shop User',
        user:localStorage.adminRefId,
        device_id:localStorage.deviceid,
        enabled:1
      }
      this.DBservice.update_playerid(datas)
        // .map(res => res.json())
        .then(data => {
          console.log(data)
        }, error => {
          console.log(JSON.stringify(error.json()));

        });
    }
  }
  // update_playid() {
  //   if (localStorage.adminRefId) {
  //     var datas = {
  //       player_id: localStorage.deviceid,
  //       user:localStorage.adminRefId,
  //       user_type:"Shop User"

  //     }
  //     this.DBservice.update_playerid(datas)
  //       // .map(res => res.json())
  //       .then(data => {
  //         console.log(data)
  //       }, error => {
  //         console.log(JSON.stringify(error.json()));

  //       });
  //   }
  // }

  ionViewDidEnter() {
    setTimeout(() => {
      this.pageloaded = true;
    }, 1000);
  }

   ionViewDidLoad() {
    this.pageloaded = false;
  }

getOrder(isOnline) {
    console.log(isOnline)
    var value;
    if(isOnline == true)
      value= 1
    else
      value = 0
    var data={
        business:localStorage.restaurant,
        available: value
    }
    this.DBservice.update_restaurant_closing(data)
      .subscribe(res => {
      // .then(res => {
        // console.log(data.data);
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
    }

  myStyle(css): object {
    // var cardcss = String(css).split(';')
    // var style= cardcss[1].split(':')
    // return {'background-image':style[1],height:'100px'};
    return css
  }

  dashboard() {
    if(this.dashboards.length == 0){
    var data = {
      user: localStorage.AdminId
    }
    this.DBservice.dashboard_info(data)
      .then((data) => {
        this.dashboards = data.message[0]
        for (var i = 0; i < this.dashboards.counter_list.length; i++) {
          if (this.dashboards.counter_list[i].show_graph == 1) {
            var options = this.dashboards.counter_list[i].chart_options
            this.chartcount(this.dashboards.counter_list[i].id, options)
          }
        }
        if (data.message[1].graph) {
          var options = data.message[1].graph.chart_options
          this.chartcount('#chart', options)
        }
      }, error => {
        console.log(JSON.stringify(error.json()));
      });
    }
  }

  chartcount(id, options) {
    var chart = new ApexCharts(document.querySelector(id), options);
    chart.render();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts